import { lazy } from 'react';

// Code-splitting helper (speed pass 2026-10-11). Every screen used to ship in
// ONE 1.5 MB script that an older machine had to download and parse before
// anything appeared. Now each screen is its own small file, fetched the first
// time it is opened.
//
// The one trap with split files: after a new version is deployed, the old
// file names no longer exist, so a browser tab that was left open from
// yesterday fails to fetch a screen it has not opened yet. When that happens
// we reload the page ONCE (the new version loads, and the open panels are
// restored by usePanelManager); if it still fails, the real error surfaces.
const RELOAD_KEY = 'talit-chunk-reload-at';

function loadWithRetry(importer) {
  return importer().catch((err) => {
    let last = 0;
    try { last = Number(sessionStorage.getItem(RELOAD_KEY) || 0); } catch { /* storage may be blocked */ }
    if (Date.now() - last > 30000) {
      try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* ignore */ }
      window.location.reload();
      return new Promise(() => {}); // the page is reloading; never resolve
    }
    throw err;
  });
}

export default function lazyWithRetry(importer) {
  const Component = lazy(() => loadWithRetry(importer));
  // Lets idle time warm a screen up before its first click.
  Component.preload = () => loadWithRetry(importer).catch(() => {});
  return Component;
}
